/**
 * LaunchDarkly flag: on, the renderer starts and streams audio-note summaries
 * itself and main only persists the recording; off, main runs the legacy
 * summary flow. Read in both processes so they agree on who calls the route.
 */
export const RENDERER_OWNED_SUMMARIES_FLAG = 'renderer-owned-audio-summaries'

/**
 * How long after a backend-confirmed save the renderer still auto-starts the
 * summary. The confirmation is replayed GlobalState, so a renderer that mounts
 * late sees it too; past this window it leaves the note to the backend's own
 * delayed generation task rather than retrying on every reload.
 */
export const SUMMARY_AUTOSTART_WINDOW_MS = 10 * 60_000
